var exports = {
  "i": "ConnectionNagbar.module__message___eGM0UF",
  "q": "ConnectionNagbar.module__indicator___eGM0UF",
};

module.exports = exports;
